import { render, staticRenderFns } from "./SankeyChart.vue?vue&type=template&id=5e415853&scoped=true&"
import script from "./SankeyChart.vue?vue&type=script&lang=js&"
export * from "./SankeyChart.vue?vue&type=script&lang=js&"
import style0 from "./SankeyChart.vue?vue&type=style&index=0&id=5e415853&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e415853",
  null
  
)

export default component.exports